export default __webpack_public_path__ + "static/media/martian.e9981292.svg";